import React from 'react';
import { Icon } from '@iconify/react';
import PurchaseOrderPrintView from './PurchaseOrderPrintView';

const PurchaseOrderPanelView = ({
  purchaseOrders = [],
  selectedOrder,
  setSelectedOrder,
  listContainerRef,
  poLoading = false,
  orderLines = [],
  handleEdit,
  handleApprove,
  handleCancel,
  onExportPdf,
  notFound = false,
}) => {
  return (
    <div className="row pb-16 pe-16" style={{ height: 'calc(100vh - 210px)' }}>
      <div className="col-md-5 h-100 d-flex flex-column ps-32">
        <div
          className="table-responsive flex-grow-1 overflow-auto scroll"
          style={{ border: 'solid #eee 2px', borderRadius: '8px', }}
          ref={listContainerRef}
        >
          <table className="table table-hover mb-0 panel-table">
            <thead>
              <tr>
                <th style={{ display: 'none' }}></th>
              </tr>
            </thead>
            <tbody>
              {purchaseOrders.length === 0 && !poLoading ? (
                <tr className='border-bottom'>
                  <td className="text-center">No Purchase Orders</td>
                </tr>
              ) : (
                purchaseOrders.map((row, idx) => {
                  const statusColour = row.status?.colours?.bootstrapName || 'secondary';
                  return (
                    <tr
                      key={`${row.id}-${idx}`}
                      onClick={() => setSelectedOrder(row)}
                      className={selectedOrder?.id === row.id ? 'notification-selected' : ''}
                    >
                      <td>
                        <div className="d-flex gap-2 align-items-start justify-content-between">
                          <div>
                            <div className="fw-bold">
                              {row.poNumber} – {row.supplier?.name || ''}
                            </div>
                            <div className="text-muted text-sm">
                              {row.orderDate ? row.orderDate.slice(0, 10) : ''}
                            </div>
                          </div>
                          <div className="text-sm text-end">
                            {row.status && (
                              <span className={`bg-${statusColour}-focus text-${statusColour}-main px-16 py-2 rounded-pill fw-medium text-sm`}>
                                {row.status.status}
                              </span>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
            {poLoading && (
              <div className="text-center py-2">
                <span className="spinner-border spinner-border-sm" />
              </div>
            )}
        </div>
      </div>
      <div className="col-md-7 h-100 d-flex flex-column">
        {selectedOrder && (
          <div 
            className="card flex-grow-1 d-flex flex-column overflow-hidden"
            style={{border: 'solid #eee 2px', borderRadius: '8px'}}
          >
            <div className="card-header flex-shrink-0 card border-0">
              <div className="row align-items-center">
                  <div className="col-6 d-flex align-items-center gap-2">
                    <h5 className="text-xl mb-0 d-flex align-items-center gap-2">
                      #{selectedOrder.poNumber}
                    </h5>
                  </div>
                <div className="col-6 d-flex justify-content-end gap-2">
                  {handleApprove && selectedOrder?.statusId === 1 && (
                    <button
                      type="button"
                      className="btn btn-outline-success btn-sm my-6"
                      onClick={() => handleApprove(selectedOrder)}
                    >
                      <Icon icon="mage:check" className="text-xl me-6" style={{ position: 'relative', top: '-1px' }} />
                      Approve
                    </button>
                  )}
                  <div className="dropdown">
                    <button
                      type="button"
                      className="btn text-primary-600 hover-text-primary px-18 show border-0 text-xxl py-4 my-6"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <Icon
                        icon="mdi:dots-vertical"
                        className='text-primary'
                        style={{ position: 'relative', top: '-5px' }}
                      />
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end mt-12">
                      {handleEdit && (
                        <li>
                          <button
                            type="button"
                            className="dropdown-item py-12"
                            onClick={() => handleEdit(selectedOrder)}
                          >
                            Edit Purchase Order
                          </button>
                        </li>
                      )}
                      {onExportPdf && (
                        <li>
                          <button
                            type="button"
                            className="dropdown-item py-12"
                            onClick={() => onExportPdf(selectedOrder)}
                          >
                            Export to PDF
                          </button>
                        </li>
                      )}
                      {handleCancel && selectedOrder?.status?.status !== 'Approved' && (
                        <li>
                          <button
                            type="button"
                            className="dropdown-item py-12 text-start text-danger"
                            onClick={() => handleCancel(selectedOrder)}
                          >
                            Cancel
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body overflow-auto flex-grow-1">
              <PurchaseOrderPrintView order={selectedOrder} orderLines={orderLines} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PurchaseOrderPanelView;
